module.exports = __webpack_public_path__ + "static/media/starry-night.372e5bc4.jpeg";